module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/electric/mixer-c9379b9fd3b42e045e130ab71bcf965e.svg";